import { render, staticRenderFns } from "./AddUsers.vue?vue&type=template&id=420bc652&scoped=true&"
import script from "./AddUsers.vue?vue&type=script&lang=ts&"
export * from "./AddUsers.vue?vue&type=script&lang=ts&"
import style0 from "./AddUsers.vue?vue&type=style&index=0&id=420bc652&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420bc652",
  null
  
)

export default component.exports